// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PopupHeader__theme-1-ccb1b8,
.PopupHeader__theme-3-e13427 {
  --height: 56px;
  --align: center;
  --display-actions: block;
  --padding: 0px 24px;
  --padding-with-actions: 0px 64px;
  --font: var(--font-title-8);
  --font-spacing: var(--font-spacing-title-8);
  --content-gap: 8px;
  --content-padding: 0 4px;
}

.PopupHeader__theme-1-ccb1b8 {
  --border: 1px solid var(--base-30);
}

.PopupHeader__theme-2-ede3b0 {
  --height: 72px;
  --align: start;
  --border: none;
  --display-actions: none;
  --padding: 0px 24px;
  --padding-with-actions: 0px 24px;
  --font: var(--font-title-9);
  --font-spacing: var(--font-spacing-title-9);
  --content-gap: 8px;
  --content-padding: 0 4px;
}

.PopupHeader__theme-3-e13427 {
  --border: none;
}

.PopupHeader__container-d36a82 {
  height: var(--height);
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  justify-content: var(--align);
  align-items: center;
  padding: var(--padding);
  border-bottom: var(--border);
  position: relative;
}

.PopupHeader__container-d36a82.PopupHeader__has-actions-e26871 {
  padding: var(--padding-with-actions);
}

.PopupHeader__content-bd0d9f {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: flex-end;
  gap: var(--content-gap);
  padding: var(--content-padding);
}

.PopupHeader__title-d5fe0e {
  font: var(--font);
  letter-spacing: var(--font-spacing);
  color: var(--base-110);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.PopupHeader__close-d8f525 {
  display: var(--display-actions);
  position: absolute;
  inset-inline-end: 24px;
}

.PopupHeader__arrow-block-ebfccd {
  display: var(--display-actions);
  position: absolute;
  inset-inline-start: 24px;
}

:root[dir=rtl] .PopupHeader__arrow-block-ebfccd {
  transform: scaleX(-1);
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/PopupHeader/PopupHeader.style.m.css"],"names":[],"mappings":"AAAA;;EAEE,cAAA;EACA,eAAA;EACA,wBAAA;EACA,mBAAA;EACA,gCAAA;EACA,2BAAA;EACA,2CAAA;EACA,kBAAA;EACA,wBAAA;AACF;;AAEA;EACE,kCAAA;AACF;;AAEA;EACE,cAAA;EACA,cAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,gCAAA;EACA,2BAAA;EACA,2CAAA;EACA,kBAAA;EACA,wBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,qBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;EACA,uBAAA;EACA,4BAAA;EACA,kBAAA;AACF;;AAEA;EACE,oCAAA;AACF;;AAEA;EACE,aAAA;EACA,OAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,+BAAA;AACF;;AAEA;EACE,iBAAA;EACA,mCAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,+BAAA;EACA,kBAAA;EACA,sBAAA;AACF;;AAEA;EACE,+BAAA;EACA,kBAAA;EACA,wBAAA;AACF;;AAEA;EACE,qBAAA;AACF","sourcesContent":[".theme-1,\n.theme-3 {\n  --height: 56px;\n  --align: center;\n  --display-actions: block;\n  --padding: 0px 24px;\n  --padding-with-actions: 0px 64px;\n  --font: var(--font-title-8);\n  --font-spacing: var(--font-spacing-title-8);\n  --content-gap: 8px;\n  --content-padding: 0 4px;\n}\n\n.theme-1 {\n  --border: 1px solid var(--base-30);\n}\n\n.theme-2 {\n  --height: 72px;\n  --align: start;\n  --border: none;\n  --display-actions: none;\n  --padding: 0px 24px;\n  --padding-with-actions: 0px 24px;\n  --font: var(--font-title-9);\n  --font-spacing: var(--font-spacing-title-9);\n  --content-gap: 8px;\n  --content-padding: 0 4px;\n}\n\n.theme-3 {\n  --border: none;\n}\n\n.container {\n  height: var(--height);\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: row;\n  justify-content: var(--align);\n  align-items: center;\n  padding: var(--padding);\n  border-bottom: var(--border);\n  position: relative;\n}\n\n.container.has-actions {\n  padding: var(--padding-with-actions);\n}\n\n.content {\n  display: flex;\n  flex: 1;\n  align-items: center;\n  justify-content: flex-end;\n  gap: var(--content-gap);\n  padding: var(--content-padding);\n}\n\n.title {\n  font: var(--font);\n  letter-spacing: var(--font-spacing);\n  color: var(--base-110);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.close {\n  display: var(--display-actions);\n  position: absolute;\n  inset-inline-end: 24px;\n}\n\n.arrow-block {\n  display: var(--display-actions);\n  position: absolute;\n  inset-inline-start: 24px;\n}\n\n:root[dir='rtl'] .arrow-block {\n  transform: scaleX(-1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"theme-1": `PopupHeader__theme-1-ccb1b8`,
	"theme1": `PopupHeader__theme-1-ccb1b8`,
	"theme-3": `PopupHeader__theme-3-e13427`,
	"theme3": `PopupHeader__theme-3-e13427`,
	"theme-2": `PopupHeader__theme-2-ede3b0`,
	"theme2": `PopupHeader__theme-2-ede3b0`,
	"container": `PopupHeader__container-d36a82`,
	"has-actions": `PopupHeader__has-actions-e26871`,
	"hasActions": `PopupHeader__has-actions-e26871`,
	"content": `PopupHeader__content-bd0d9f`,
	"title": `PopupHeader__title-d5fe0e`,
	"close": `PopupHeader__close-d8f525`,
	"arrow-block": `PopupHeader__arrow-block-ebfccd`,
	"arrowBlock": `PopupHeader__arrow-block-ebfccd`
};
module.exports = ___CSS_LOADER_EXPORT___;
